<div *ngIf="this.loader.getLoading()">
    <div class="p-fl-container"></div>
    <div class="flex p-fl-spinner">
        <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
    </div>
</div>